import { render, staticRenderFns } from "./TripDetailsPage.vue?vue&type=template&id=b86a5056"
import script from "./TripDetailsPage.vue?vue&type=script&lang=ts"
export * from "./TripDetailsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports